import React from 'react'
import quality from '../Assets/Images/quality.png'
import certified from '../Assets/Images/certified.png'
import experience from '../Assets/Images/experience.png'
import { Container } from 'react-bootstrap'

const Quality = () => {
  return (
    <div className='border-b-yellow-500 bg-accent1 mb-2 border-b-8'>
        <Container className='px-4 py-5 '>
        <h2 className='text-2xl font-thin tracking-wide text-textColor-100 subpixel-antialiased mb-4 text-center'>Certified Excellence in Quality</h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className='flex items-center flex-col'>
                <div className="h-24 w-24 mb-2 bg-white border-2 rounded-full flex items-center justify-center border-yellow-400">
                    <img src={certified} alt="quality-icon" className='h-12 w-12 object-contain'/>
                </div>
                <h4 className='text-lg tracking-wider text-textColor-100 subpixel-antialiased mb-2 text-center uppercase'>CERTIFIED</h4>
                <p className='text-base text-textColor-100 text-center'>
                Oyoyo Lubricants are certified by the Standards Organisation of Nigeria (SON) as part of the Mandatory Conformity Assessment Programme (MANCAP).
                </p>
            </div>
            <div className='flex items-center flex-col'>
                <div className="h-24 w-24 mb-2 bg-white border-2 rounded-full flex items-center justify-center border-yellow-400">
                    <img src={experience} alt="quality-icon" className='h-10 w-10 object-contain'/>
                </div>
                <h4 className='text-lg tracking-wider text-textColor-100 subpixel-antialiased mb-2 text-center uppercase'>Experience</h4>
                <p className='text-base text-textColor-100 text-center'>
                Our management officers are duly certified and possess extensive knowledge and experience in lubricant sales and production across Nigeria and West Africa.
                </p>
            </div>
            <div className='flex items-center flex-col'>
                <div className="h-24 w-24 mb-2 bg-white border-2 rounded-full flex items-center justify-center border-yellow-400">
                    <img src={quality} alt="quality-icon" className='h-12 w-12 object-contain'/>
                </div>
                <h4 className='text-lg tracking-wider text-textColor-100 subpixel-antialiased mb-2 text-center uppercase'>quality</h4>
                <p className='text-base text-textColor-100 text-center'>
                We utilize top-quality ingredients in our lubricants to guarantee that our products meet and exceed consumer expectations. 
                </p>
            </div>
        </div>
      
    </Container>
    </div>
    
  )
}

export default Quality
